import React from 'react';
import { Box, Skeleton, Paper } from '@mui/material';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  showFilters?: boolean;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 8,
  columns = 6,
  showFilters = true,
}) => (
  <Box>
    {showFilters && (
      <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <Skeleton variant="rounded" width={180} height={40} />
        <Skeleton variant="rounded" width={180} height={40} />
        <Skeleton variant="rounded" width={240} height={40} />
      </Box>
    )}
    <Paper sx={{ overflow: 'hidden' }}>
      {/* Header row */}
      <Box sx={{ display: 'flex', gap: 2, px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={i} variant="text" width={`${100 / columns}%`} height={24} />
        ))}
      </Box>
      {/* Data rows */}
      {Array.from({ length: rows }).map((_, row) => (
        <Box
          key={row}
          sx={{
            display: 'flex',
            gap: 2,
            px: 2,
            py: 1.2,
            borderBottom: 1,
            borderColor: 'divider',
            '&:last-child': { borderBottom: 0 },
          }}
        >
          {Array.from({ length: columns }).map((_, col) => (
            <Skeleton
              key={col}
              variant="text"
              width={`${100 / columns}%`}
              height={20}
              sx={{ opacity: 1 - row * 0.08 }}
            />
          ))}
        </Box>
      ))}
    </Paper>
  </Box>
);

interface DashboardSkeletonProps {
  tabs?: number;
}

export const DashboardSkeleton: React.FC<DashboardSkeletonProps> = ({ tabs = 6 }) => (
  <Box>
    {/* Date selector */}
    <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center' }}>
      <Skeleton variant="rounded" width={200} height={40} />
    </Box>
    {/* Tabs */}
    <Box sx={{ display: 'flex', gap: 1, mb: 3, borderBottom: 1, borderColor: 'divider', pb: 1 }}>
      {Array.from({ length: tabs }).map((_, i) => (
        <Skeleton key={i} variant="rounded" width={90} height={32} />
      ))}
    </Box>
    {/* Filter row */}
    <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
      <Skeleton variant="rounded" width={150} height={40} />
      <Skeleton variant="rounded" width={150} height={40} />
      <Skeleton variant="rounded" width={200} height={40} />
    </Box>
    {/* Table */}
    <TableSkeleton rows={10} columns={7} showFilters={false} />
  </Box>
);

export const ContestSkeleton: React.FC = () => (
  <Box>
    <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
      <Skeleton variant="rounded" width={160} height={40} />
      <Skeleton variant="rounded" width={240} height={40} />
    </Box>
    <TableSkeleton rows={6} columns={4} showFilters={false} />
  </Box>
);
